export default __webpack_public_path__ + "static/media/Empty state_Leaderboard4.1009139d.png";